export function getRugbyStatisticHeader() {
  return [
    {
      id: 'gamesCount',
      title: 'Игр'
    },
    {
      id: 'wonGamesCount',
      title: 'Победы'
    },
    {
      id: 'loseGamesCount',
      title: 'Поражения'
    },
    {
      id: 'drawGamesCount',
      title: 'Ничьи'
    },
    {
      id: 'tries',
      title: 'Попытки'
    },
    {
      id: 'conversionGoals',
      title: 'Реализации'
    },
    {
      id: 'dropGoals',
      title: 'Дроп-голы'
    },
    {
      id: 'dropGoalKicks',
      title: 'Попыток дроп-гола'
    },
    {
      id: 'penaltyGoals',
      title: 'Забитые штрафные'
    },
    {
      id: 'penaltyKicksOnGoal',
      title: 'Исполненных штрафных'
    },
    {
      id: 'points',
      title: 'Очки'
    },
    {
      id: 'tackles',
      title: 'Захваты'
    },
    {
      id: 'runs',
      title: 'Забеги'
    },
    {
      id: 'yellowCards',
      title: 'Жёлтые карточки'
    },
    {
      id: 'redCards',
      title: 'Красные карточки'
    },
    {
      id: 'plusMinus',
      title: '+/-'
    }
  ];
}
